import { AppContext } from "@context/app.ctx"
import Script from "next/script"
import type { MouseEvent } from "react"
import { useContext, useState } from "react"

export const SUPPORT_WHATSAPP_URL = 'https://wa.me/5511937036875'

export const IS_TAWKTO_ENABLED = JSON.parse(
  process.env.NEXT_PUBLIC_ENABLE_TAWKTO || 'false'
)

type TawkApi = {
  isChatMaximized?: () => boolean
  maximize?: () => void
  minimize?: () => void
  showWidget?: () => void
  onLoad?: () => void
  setAttributes?: (
    attrs: Record<string, string>,
    errorCallback?: (error: string) => void
  ) => void
}

declare global {
  interface Window {
    Tawk_API?: TawkApi
  }
}

const runTawkToggle = (api: TawkApi) => {
  if (api.isChatMaximized?.()) {
    api.minimize?.()
    return
  }

  api.showWidget?.()
  api.maximize?.()
}

export const toggleTawkTo = (event?: MouseEvent) => {
  event?.preventDefault()

  const api = window.Tawk_API
  if (!api) return

  if (typeof api.maximize === 'function' || typeof api.isChatMaximized === 'function') {
    runTawkToggle(api)
    return
  }

  const previousOnLoad = api.onLoad
  api.onLoad = function () {
    if (typeof previousOnLoad === 'function') {
      previousOnLoad.call(this)
    }
    runTawkToggle(api)
  }
}

export const TawkTo = () => {
  const { user, profile, invoicePending } = useContext(AppContext)
  const [loaded, setLoaded] = useState(false);

  if (typeof window.Tawk_API?.setAttributes === 'function' && !loaded) {
    fetch('/api/tawkto', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: user?.email })
    })
      .then(res => res.json())
      .then(data => {
        setLoaded(true);
        const message: { [key: string]: string } = {
          paid: `Fatura ${invoicePending?.invoices[0]?.expiration} Paga!`,
          canceled: `Fatura ${invoicePending?.invoices[0]?.expiration} Cancelada!`,
          pending: invoicePending?.invoices[0]?.invoice_code?.includes(
            'order_'
          )
            ? `https://grovepay.com.br/order/${invoicePending.invoices[0]?.invoice_code}`
            : invoicePending?.invoices[0]?.requests.toReversed()[0]
              ?.paghiper &&
            invoicePending?.invoices[0]?.requests.toReversed()[0]
              ?.paghiper[0]?.create_request?.bank_slip?.url_slip
        }
        window.Tawk_API?.setAttributes?.({
          name: user.name,
          email: user.email,
          slug: profile.slug,
          status: profile.status ? 'Ativo' : 'Bloqueado',
          fatura: invoicePending?.invoices[0]?.status ? message[invoicePending?.invoices[0]?.status] : 'Sem faturas',
          hash: data.hash,
        }, console.error)
      })
  }

  return (
    <>
      <Script
        id="talkto"
        src="/scripts/tawkto.js"
        strategy="afterInteractive"
      />
    </>
  )
}
